<template>
    <span>{{filterPhone(phone)}}</span>
</template>

<script>
    export default {
        props: ['phone', 'disabled'],
        data() {
            return {}
        },
        methods: {
            filterPhone(phone) {
                if (!this.$store.state.user.permissions.includes('contactInfoShow')) {
                  return phone.replace(/(\d{3})(\d{4})(\d{2})/, '$1xxxx$3');
                }
                return phone;
            }
        },
    };
</script>